import { getBrowserSupabaseClient } from "@wtc/supabase";
import { logger } from "@/lib/logger";

// Base API configuration
export const API_BASE = "/api";

// Supabase client helper - creates fresh instance each time to avoid stale auth state
export const getSupabase = () => getBrowserSupabaseClient();

// Debug wrapper to log each table access once
const loggedTables = new Set<string>();
export const getSupabaseWithLogging = () => {
  const client = getBrowserSupabaseClient();
  // Log session/token once per page load
  void (async () => {
    try {
      const { data } = await client.auth.getSession();
      const token = data.session?.access_token || null;
      const userEmail = data.session?.user?.email;
      logger.info("🔑 Supabase session", {
        hasSession: !!data.session,
        userEmail,
        tokenPrefix: token ? token.slice(0, 12) : null,
      });
    } catch (e) {
      logger.warn("🔑 Supabase session fetch failed", { error: e });
    }
  })();
  const originalFrom = client.from.bind(client);
  (client as any).from = (table: string) => {
    if (!loggedTables.has(table)) {
      logger.info(`📦 Supabase.from("${table}")`);
      loggedTables.add(table);
    }
    return originalFrom(table);
  };
  return client;
};
